import { useDispatch } from "react-redux";
import "./HeaderMenu.css";
import { setLeftPanelActiveTab } from "../../store/appSlice";
import { LeftPanelTabs } from "../../constants/Panels";

interface LeftHeaderMenuProps {
    onClose: () => void;
}
const LeftHeaderMenu = ({ onClose }: LeftHeaderMenuProps) => {

    const dispatch = useDispatch();

    const openCatalog = () => {
        onClose();
        dispatch(setLeftPanelActiveTab(LeftPanelTabs.CATALOG));
    }

    const openSearchResults = () => {
        onClose();
        dispatch(setLeftPanelActiveTab(LeftPanelTabs.SEARCH));
    }

    return (
        <div className="header-menu-container">
            <button className="header-menu-button" onClick={openCatalog}>Katalog</button>
            <button className="header-menu-button" onClick={openSearchResults}>Søkeresultater</button>
        </div>
    );
};

export default LeftHeaderMenu;
